/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';

const RemoteSvg = ({ className, url, width = 20, height = 20, fill = '#959DA9', color = '#959DA9', margin }) => {
  const [svgContent, setSvgContent] = useState(null);
  if (!url) {
    return null;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const fetchSvg = async () => {
      try {
        const response = await fetch(url);
        const text = await response.text();
        setSvgContent(text);
      } catch (error) {
        console.error('Error fetching SVG:', error);
      }
    };

    fetchSvg();
  }, [url]);

  return (
    <div
      className={`${className} flex align-center justify-center`}
      style={{ width, height, margin }}
      dangerouslySetInnerHTML={{ __html: svgContent ? svgContent.replace(/fill="[^"]*"/g, `fill="${fill}"`) : '' }}
    />
  );
};

export default RemoteSvg;
